import DocumentationButton from "components/DocumentationButton";
import {
  EmptystatePuzzleColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";
import LinkButton from "ds/components/Button/LinkButton";
import useCanCreateContext from "shared/Context/access/useCanCreateContext";
import Tooltip from "ds/components/Tooltip";

type ContextsEmptyProps = {
  hasNoSearchResult?: boolean;
};

const ContextsEmpty = ({ hasNoSearchResult }: ContextsEmptyProps) => {
  const canCreateContext = useCanCreateContext();

  return (
    <>
      {hasNoSearchResult && (
        <EmptyState
          title="No results"
          caption="Try different filters."
          icon={EmptystateSearchNoResultsColored}
          announce
        />
      )}

      {!hasNoSearchResult && (
        <EmptyState
          title="You don’t have any contexts yet"
          icon={EmptystatePuzzleColored}
          caption="Contexts are collections of reusable configuration elements that can be shared between multiple Stacks. They make your life significantly easier when dealing with repetitive settings and/or credentials."
        >
          <Box gap="medium">
            <DocumentationButton
              to={getDocsUrl("/concepts/configuration/context")}
              label="Documentation"
            />

            <Tooltip
              active={!!canCreateContext.message}
              on={(props) => (
                <LinkButton
                  {...props}
                  variant="primary"
                  to="/new/context"
                  disabled={!canCreateContext.result}
                >
                  Create context
                </LinkButton>
              )}
            >
              {canCreateContext.message}
            </Tooltip>
          </Box>
        </EmptyState>
      )}
    </>
  );
};

export default ContextsEmpty;
